import { UpDownThemeEnum } from '@/@enums/Color';
import { useTranslation } from 'react-i18next';

export const BALANCETYPE = `SPOT,CONTRACT,OTC,FINANCIAL,SUPER,COPY`;

export const COMPUTED_THEME_COLORS = {
  up: {
    [UpDownThemeEnum.greenUpRedDown]: '#2EBD85',
    [UpDownThemeEnum.redUpGreenDown]: '#F5465D',
  },
  down: {
    [UpDownThemeEnum.greenUpRedDown]: '#F5465D',
    [UpDownThemeEnum.redUpGreenDown]: '#2EBD85',
  },
};

export const SCROLL_PAGINATION_LIMIT_DEFAULT = 20;

export const FUTURES_DEFAULT_LAYOUTS = {
  lg: [
    { i: 'switch', x: 0, y: 0, w: 50, h: 4, minW: 30, minH: 4 }, // 交易对详情
    { i: 'chart', x: 0, y: 6, w: 50, h: 41, minW: 6, minH: 30 }, // K线
    { i: 'position', x: 0, y: 71.8, w: 60, h: 36, minW: 9, minH: 20 }, // 持仓
    { i: 'orderBook', x: 50, y: 0, w: 10, h: 58, minW: 10, minH: 34 }, // 盘口
    { i: 'trade', x: 50, y: 42, w: 10, h: 58, minW: 10, minH: 9 }, // 最新成交
    { i: 'handicap', x: 50, y: 0, w: 10, h: 45, minW: 10, minH: 34 }, // 盘口
    { i: 'orderForm', x: 70, y: 0, w: 10, h: 76, minW: 10, minH: 32 }, // 下单区域
  ],
  md: [
    { i: 'switch', x: 0, y: 0, w: 40, h: 4, minW: 30, minH: 4 }, // 交易对详情
    { i: 'chart', x: 0, y: 6, w: 40, h: 36, minW: 6, minH: 30 }, // K线
    { i: 'position', x: 0, y: 71.8, w: 50, h: 36, minW: 9, minH: 20 }, // 持仓
    // { i: 'orderBook', x: 40, y: 0, w: 10, h: 34, minW: 10, minH: 34 }, // 盘口
    { i: 'trade', x: 40, y: 42, w: 10, h: 18, minW: 10, minH: 9 }, // 最新成交
    { i: 'handicap', x: 40, y: 0, w: 10, h: 40, minW: 10, minH: 34 }, // 盘口
    { i: 'orderForm', x: 60, y: 0, w: 10, h: 76, minW: 10, minH: 32 }, // 下单区域
  ],
  sm: [
    { i: 'switch', x: 0, y: 0, w: 30, h: 4, minW: 30, minH: 4 }, // 交易对详情
    { i: 'chart', x: 0, y: 6, w: 30, h: 36, minW: 6, minH: 30 }, // K线
    { i: 'position', x: 0, y: 71.8, w: 40, h: 46, minW: 9, minH: 20 }, // 持仓
    // { i: 'orderBook', x: 30, y: 0, w: 10, h: 34, minW: 10, minH: 34 }, // 盘口
    { i: 'trade', x: 30, y: 42, w: 10, h: 18, minW: 10, minH: 9 }, // 最新成交
    { i: 'handicap', x: 30, y: 0, w: 10, h: 40, minW: 10, minH: 34 }, // 盘口
    { i: 'orderForm', x: 50, y: 0, w: 10, h: 86, minW: 10, minH: 32 }, // 下单区域
  ],
  xs: [
    { i: 'switch', x: 0, y: 0, w: 24, h: 4, minW: 30, minH: 4 }, // 交易对详情
    { i: 'chart', x: 0, y: 6, w: 24, h: 30, minW: 6, minH: 30 }, // K线
    { i: 'position', x: 0, y: 58, w: 32, h: 46, minW: 9, minH: 20 }, // 持仓
    { i: 'orderBook', x: 20, y: 0, w: 9, h: 34, minW: 9, minH: 34 }, // 盘口
    { i: 'trade', x: 24, y: 42, w: 9, h: 18, minW: 9, minH: 9 }, // 最新成交
    { i: 'handicap', x: 24, y: 0, w: 8, h: 34, minW: 8, minH: 34 }, // 盘口
    { i: 'orderForm', x: 40, y: 0, w: 8, h: 80, minW: 8, minH: 32 }, // 下单区域
  ],
  xxs: [
    { i: 'switch', x: 0, y: 0, w: 30, h: 6, minW: 15, minH: 6 }, // 交易对详情
    { i: 'chart', x: 0, y: 6, w: 20, h: 56, minW: 10, minH: 28 }, // K线
    { i: 'position', x: 0, y: 200, w: 30, h: 44, minW: 15, minH: 20 }, // 持仓
    { i: 'orderBook', x: 0, y: 62, w: 10, h: 38, minW: 5, minH: 20 }, // 盘口
    { i: 'trade', x: 10, y: 62, w: 10, h: 38, minW: 5, minH: 20 }, // 最新成交
    { i: 'handicap', x: 0, y: 64, w: 20, h: 38, minW: 10, minH: 30 }, // 盘口
    { i: 'orderForm', x: 20, y: 62, w: 10, h: 94, minW: 5, minH: 32 }, // 下单区域
  ],
  xxxs: [
    { i: 'switch', x: 0, y: 0, w: 10, h: 6, minW: 5, minH: 6 }, // 交易对详情
    { i: 'chart', x: 0, y: 6, w: 10, h: 36, minW: 5, minH: 18 }, // K线
    { i: 'position', x: 0, y: 112, w: 10, h: 44, minW: 5, minH: 22 }, // 持仓
    // { i: 'orderBook', x: 0, y: 181, w: 10, h: 36, minW: 5, minH: 10 }, // 盘口
    // { i: 'trade', x: 0, y: 211, w: 10, h: 20, minW: 5, minH: 10 }, // 最新成交
    { i: 'handicap', x: 0, y: 181, w: 10, h: 38, minW: 10, minH: 30 }, // 盘口
    { i: 'orderForm', x: 5, y: 42, w: 10, h: 94, minW: 5, minH: 32 }, // 下单区域
  ],
};
export const SPOT_DEFAULT_LAYOUTS = {
  lg: [
    { i: 'switch', x: 0, y: 0, w: 50, h: 4, minW: 30, minH: 4 }, // 交易对详情
    { i: 'chart', x: 0, y: 6, w: 50, h: 41, minW: 6, minH: 30 }, // K线
    { i: 'position', x: 0, y: 71.8, w: 60, h: 36, minW: 9, minH: 20 }, // 持仓
    { i: 'orderBook', x: 50, y: 0, w: 10, h: 58, minW: 10, minH: 34 }, // 盘口
    { i: 'trade', x: 50, y: 42, w: 10, h: 58, minW: 10, minH: 9 }, // 最新成交
    { i: 'handicap', x: 50, y: 0, w: 10, h: 45, minW: 10, minH: 34 }, // 盘口
    { i: 'orderForm', x: 70, y: 0, w: 10, h: 76, minW: 10, minH: 32 }, // 下单区域
  ],
  md: [
    { i: 'switch', x: 0, y: 0, w: 40, h: 4, minW: 30, minH: 4 }, // 交易对详情
    { i: 'chart', x: 0, y: 6, w: 40, h: 36, minW: 6, minH: 30 }, // K线
    { i: 'position', x: 0, y: 71.8, w: 50, h: 36, minW: 9, minH: 20 }, // 持仓
    // { i: 'orderBook', x: 40, y: 0, w: 10, h: 34, minW: 10, minH: 34 }, // 盘口
    { i: 'trade', x: 40, y: 42, w: 10, h: 18, minW: 10, minH: 9 }, // 最新成交
    { i: 'handicap', x: 40, y: 0, w: 10, h: 40, minW: 10, minH: 34 }, // 盘口
    { i: 'orderForm', x: 60, y: 0, w: 10, h: 76, minW: 10, minH: 32 }, // 下单区域
  ],
  sm: [
    { i: 'switch', x: 0, y: 0, w: 30, h: 4, minW: 30, minH: 4 }, // 交易对详情
    { i: 'chart', x: 0, y: 6, w: 30, h: 36, minW: 6, minH: 30 }, // K线
    { i: 'position', x: 0, y: 71.8, w: 40, h: 46, minW: 9, minH: 20 }, // 持仓
    // { i: 'orderBook', x: 30, y: 0, w: 10, h: 34, minW: 10, minH: 34 }, // 盘口
    { i: 'trade', x: 30, y: 42, w: 10, h: 18, minW: 10, minH: 9 }, // 最新成交
    { i: 'handicap', x: 30, y: 0, w: 10, h: 40, minW: 10, minH: 34 }, // 盘口
    { i: 'orderForm', x: 50, y: 0, w: 10, h: 86, minW: 10, minH: 32 }, // 下单区域
  ],
  xs: [
    { i: 'switch', x: 0, y: 0, w: 24, h: 4, minW: 30, minH: 4 }, // 交易对详情
    { i: 'chart', x: 0, y: 6, w: 24, h: 30, minW: 6, minH: 30 }, // K线
    { i: 'position', x: 0, y: 58, w: 32, h: 46, minW: 9, minH: 20 }, // 持仓
    { i: 'orderBook', x: 20, y: 0, w: 9, h: 34, minW: 9, minH: 34 }, // 盘口
    { i: 'trade', x: 24, y: 42, w: 9, h: 18, minW: 9, minH: 9 }, // 最新成交
    { i: 'handicap', x: 24, y: 0, w: 8, h: 34, minW: 8, minH: 34 }, // 盘口
    { i: 'orderForm', x: 40, y: 0, w: 8, h: 80, minW: 8, minH: 32 }, // 下单区域
  ],
  xxs: [
    { i: 'switch', x: 0, y: 0, w: 30, h: 6, minW: 15, minH: 6 }, // 交易对详情
    { i: 'chart', x: 0, y: 6, w: 20, h: 56, minW: 10, minH: 28 }, // K线
    { i: 'position', x: 0, y: 200, w: 30, h: 44, minW: 15, minH: 20 }, // 持仓
    { i: 'orderBook', x: 0, y: 62, w: 10, h: 38, minW: 5, minH: 20 }, // 盘口
    { i: 'trade', x: 10, y: 62, w: 10, h: 38, minW: 5, minH: 20 }, // 最新成交
    { i: 'handicap', x: 0, y: 64, w: 20, h: 38, minW: 10, minH: 30 }, // 盘口
    { i: 'orderForm', x: 20, y: 62, w: 10, h: 94, minW: 5, minH: 32 }, // 下单区域
  ],
  xxxs: [
    { i: 'switch', x: 0, y: 0, w: 10, h: 6, minW: 5, minH: 6 }, // 交易对详情
    { i: 'chart', x: 0, y: 6, w: 10, h: 36, minW: 5, minH: 18 }, // K线
    { i: 'position', x: 0, y: 112, w: 10, h: 44, minW: 5, minH: 22 }, // 持仓
    // { i: 'orderBook', x: 0, y: 181, w: 10, h: 36, minW: 5, minH: 10 }, // 盘口
    // { i: 'trade', x: 0, y: 211, w: 10, h: 20, minW: 5, minH: 10 }, // 最新成交
    { i: 'handicap', x: 0, y: 181, w: 10, h: 38, minW: 10, minH: 30 }, // 盘口
    { i: 'orderForm', x: 5, y: 42, w: 10, h: 94, minW: 5, minH: 32 }, // 下单区域
  ],
};
export type CurrencyCode = '' | 'usd' | 'krw' | 'btc' | 'inr' | 'idr' | 'cny';

export interface CurrencyItem {
  value: CurrencyCode;
  label: string;
  note: string;
}
export const payTypeArr = [
  { value: '', label: 'status.ad.payTypeArr.01', type: 0 }, // 全部交易方式
  { value: '0', label: 'status.ad.payTypeArr.02', type: 3 }, // 银行卡
  { value: '1', label: 'status.ad.payTypeArr.03', type: 1 }, // 支付宝
  { value: '2', label: 'status.ad.payTypeArr.04', type: 2 }, // 微信
];
export const paymentListData = [
  { title: 'common.bank', id: 0, styleCss: 'bankCss' },
  { title: 'common.alipay', id: 1, styleCss: 'alipayCss' },
  { title: 'common.wechat', id: 2, styleCss: 'wechatCss' },
];
export function getPayType(type: string | number) {
  const payType: any = {
    '0': 'status.ad.getPayType.01', // 银行卡
    '1': 'status.ad.getPayType.02', // 支付宝
    '2': 'status.ad.getPayType.03', // 微信
    '4': 'status.ad.getPayType.04', // 资金账户
  };
  return payType[type + ''];
}

export function getOrderListStatus(type: string) {
  const obj: any = {
    '-1': 'status.ad.getOrderListStatus.01', // 已取消
    '2': 'status.ad.getOrderListStatus.02', // 待付款
    '3': 'status.ad.getOrderListStatus.03', // 已付款
    '4': 'status.ad.getOrderListStatus.04', // 已放币
    '5': 'status.ad.getOrderListStatus.05', // 卖单审核中
  };
  return obj[type + ''];
}

export const buyStatusText = {
  '2': 'status.ad.buyStatusText.01',
  '3': 'status.ad.buyStatusText.02',
  '4': 'status.ad.buyStatusText.03',
  '-1': 'status.ad.buyStatusText.04',
  '5': 'status.ad.sellStatusText.05',
};
export const sellStatusText = {
  '2': 'status.ad.sellStatusText.01',
  '3': 'status.ad.sellStatusText.02',
  '4': 'status.ad.sellStatusText.03',
  '-1': 'status.ad.sellStatusText.04',
  '5': 'status.ad.sellStatusText.05',
};

export const chatBuyStatusText = {
  '2': 'status.ad.chatBuyStatusText.01',
  '3': 'status.ad.chatBuyStatusText.02',
  '4': 'status.ad.chatBuyStatusText.03',
  '-1': 'status.ad.chatBuyStatusText.04',
  '5': 'status.ad.chatSellStatusText.05',
};
export const chatSellStatusText = {
  '2': 'status.ad.chatSellStatusText.01',
  '3': 'status.ad.chatSellStatusText.02',
  '4': 'status.ad.chatSellStatusText.03',
  '-1': 'status.ad.chatSellStatusText.04',
  '5': 'status.ad.chatSellStatusText.05',
};

export const coinsArr = [
  { value: 'USDT', label: 'USDT' },
  { value: 'BTC', label: 'BTC' },
  { value: 'ETH', label: 'ETH' },
  { value: 'Aave', label: 'Aave' },
  { value: 'Bch', label: 'Bch' },
  { value: 'Cake', label: 'Cake' },
];
export const paperArr = [
  { value: 'CNY', label: 'CNY' },
  { value: 'USD', label: 'USD' },
  { value: 'JAY', label: 'JAY' },
  { value: 'VND', label: 'VND' },
  { value: 'ZWD', label: 'ZWD' },
];

export const CURRENCY_LIST: CurrencyItem[] = [
  { value: 'usd', label: 'USD', note: '$' },
  // { value: 'krw', label: 'KRW', note: '€' },
  // { value: 'btc', label: 'BTC', note: '฿' },
  // { value: 'inr', label: 'INR', note: '₹' },
  // { value: 'idr', label: 'IDR', note: 'Rp' },
  { value: 'cny', label: 'CNY', note: '￥' },
];

export type LangCode = '' | 'en' | 'ko' | 'ja' | 'hi' | 'in' | 'ru' | 'es' | 'hk' | 'zh' | 'tr' | 'vi';
export type StatusCode = 1 | 2 | 3 | 4 | 5;
export type OrderStatusCode = 1 | 2 | 3 | 4 | 5 | -1;
export type DerctionCode = '' | 'B' | 'S';

export function getZenLan(lang: LangCode) {
  const defaultLan = 'en-us';
  const zenLan: {
    [key in LangCode]: string;
  } = {
    '': defaultLan,
    en: defaultLan,
    ko: 'ko-kr',
    ja: 'ja',
    hi: defaultLan,
    in: defaultLan,
    ru: 'ru',
    es: defaultLan,
    hk: 'zh-tw',
    zh: 'zh-cn',
    tr: defaultLan,
    vi: defaultLan,
  };

  return zenLan[lang] || defaultLan;
}

export interface LangItem {
  value: LangCode;
  label: string;
}

export const LANG_LIST: LangItem[] = [
  { value: 'zh', label: '简体中文' },
  { value: 'en', label: 'English' },
  // { value: 'ko', label: '한국어' },
  // { value: 'ja', label: '日本語' },
  // { value: 'hi', label: 'हिंदी' },
  // { value: 'in', label: 'Bahasa Indonesia' },
  // { value: 'ru', label: 'русский' },
  // { value: 'es', label: 'Español' },
  // { value: 'tr', label: 'Türkçe' },
  { value: 'hk', label: '繁體中文' },
  { value: 'vi', label: 'Tiếng Việt' },
];
export const getDefaultCurrencyByLang = (lang: LangCode): CurrencyCode => (lang === 'zh' || lang === 'hk' ? 'cny' : 'usd');
export const ORDER_CONFIRM_LIST: any[] = [
  { value: true, label: '开启' },
  { value: false, label: '关闭' },
];
export const FAVOR_LIST: any[] = [
  { value: 'greenUpRedDown', label: 'header.greenup' },
  { value: 'redUpGreenDown', label: 'header.redup' },
];
export function getDirection(direction: string) {
  const zenLan: any = {
    B: 'btn.buy',
    S: 'btn.sell',
  };

  return zenLan[direction];
}

export function getStatus(status: StatusCode) {
  const zenLan: any = { 1: 'status.ad.01', 2: 'status.ad.02', 3: 'status.ad.03', 4: 'status.ad.04', 5: 'status.ad.05' };

  return zenLan[status];
}
export const AD_STATUS_LIST: any = [
  { value: '1', label: 'status.ad.01' },
  { value: '2', label: 'status.ad.02' },
  { value: '3', label: 'status.ad.03' },
  { value: '4', label: 'status.ad.04' },
  { value: '5', label: 'status.ad.05' },
];
export const AD_DERECTION_LIST: any = [
  { value: 'B', label: 'btn.buy' },
  { value: 'S', label: 'btn.sell' },
];
export function getOrderStatus(status: OrderStatusCode) {
  const zenLan: any = {
    1: 'status.ad.order.01',
    2: 'status.ad.order.02',
    3: 'status.ad.order.03',
    4: 'status.ad.order.04',
    5: 'status.ad.order.05',
    '-1': 'status.ad.order.06',
  };

  return zenLan[status];
}

export const getLangValueByLabel = (label: LangItem['label']) => LANG_LIST.find(item => item.label === label)?.value;

export const getCurrencyValueByLabel = (label: CurrencyItem['label']) =>
  CURRENCY_LIST.find(item => item.label === label)?.value;
export const get = (label: CurrencyItem['label']) => CURRENCY_LIST.find(item => item.label === label)?.value;
// 充值提现状态
export const STATUS_DAW: any = {
  0: {
    styleBgCss: 'status_success',
    styleTextCss: 'status_success_text',
    text: 'status.success',
    text_withdraw: 'status.success2',
  },
  1: {
    styleBgCss: 'status_other',
    styleTextCss: 'status_other_text',
    text: 'status.progress',
    text_withdraw: 'status.progress',
  },
  2: {
    styleBgCss: 'status_fail',
    styleTextCss: 'status_fail_text',
    text: 'status.cancel',
    text_withdraw: 'status.cancel',
  },
  '-1': {
    styleBgCss: 'status_fail',
    styleTextCss: 'status_fail_text',
    text: 'status.fail',
    text_withdraw: 'status.fail',
  },
  3: {
    styleBgCss: 'status_other',
    styleTextCss: 'status_other_text',
    text: 'status.confirm',
    text_withdraw: 'status.confirm',
  },
  4: {
    styleBgCss: 'status_other',
    styleTextCss: 'status_other_text',
    text: 'status.audited',
    text_withdraw: 'status.audited',
  },
  5: {
    styleBgCss: 'status_other',
    styleTextCss: 'status_other_text',
    text: 'status.pendingPacking',
    text_withdraw: 'status.pendingPacking',
  },
  6: {
    styleBgCss: 'status_fail',
    styleTextCss: 'status_fail_text',
    text: 'status.systemError',
    text_withdraw: 'status.systemError',
  },
  7: {
    styleBgCss: 'status_back',
    styleTextCss: 'status_back_text',
    text: 'status.rejected',
    text_withdraw: 'status.rejected',
  },
  8: {
    styleBgCss: 'status_fail',
    styleTextCss: 'status_fail_text',
    text: 'status.cancelTimeout',
    text_withdraw: 'status.cancelTimeout',
  },
  9: {
    styleBgCss: 'status_fail',
    styleTextCss: 'status_fail_text',
    text: 'status.abnormal',
    text_withdraw: 'status.abnormal',
  },
};
// 综合账单类型
export const BILL_TYPE: any = {
  WITHDRAW: {
    styleBgCss: 'status_success',
    styleTextCss: 'status_success_text',
    text: 'status.bill.withdrawal',
  },
  DEPOSIT: {
    styleBgCss: 'status_other',
    styleTextCss: 'status_other_text',
    text: 'status.bill.recharge',
  },
  CANCEL_WITHDRAW: {
    styleBgCss: 'status_fail',
    styleTextCss: 'status_fail_text',
    text: 'status.bill.cancelWithdrawal',
  },
  DEPOSITE_INTERNAL_TRANSFER: {
    styleBgCss: 'status_fail',
    styleTextCss: 'status_fail_text',
    text: 'status.bill.depositeInternalTransfer',
  },
  CREATE_TRADE: {
    styleBgCss: 'status_fail',
    styleTextCss: 'status_fail_text',
    text: 'status.bill.orderFrozen',
  },
  DEAL_FEE_TO_ACCUMULATED: {
    styleBgCss: 'status_other',
    styleTextCss: 'status_other_text',
    text: 'status.bill.fee',
  },
  TRADE_DEAL: {
    styleBgCss: 'status_other',
    styleTextCss: 'status_other_text',
    text: 'status.bill.orderClosed',
  },
  CANCEL_TRADE: {
    styleBgCss: 'status_other',
    styleTextCss: 'status_other_text',
    text: 'status.bill.cancel',
  },
  exchange: {
    styleBgCss: 'status_fail',
    styleTextCss: 'status_fail_text',
    text: 'status.bill.transfer',
  },
  fictitious: {
    styleBgCss: 'status_back',
    styleTextCss: 'status_back_text',
    text: 'status.bill.fictitious',
  },
  UNREAL_INTERNAL_TRANSFER: {
    styleBgCss: 'status_fail',
    styleTextCss: 'status_fail_text',
    text: 'status.bill.unrealInternalTransfer',
  },
  CHANNEL_SEND_REBADE: {
    styleBgCss: 'status_fail',
    styleTextCss: 'status_other_text',
    text: 'status.bill.channelSendRebade',
  },
};
// 充值提现状态
export const TYPE_DAW: any = {
  1: {
    text: 'common.deposits',
  },
  '-1': {
    text: 'common.withdraws',
  },
  '-2': {
    text: 'account.assets.withdraws.nbzz',
  },
};
export const ORDER_STATE: any = {
  FILLED: {
    styleBgCss: 'status_success',
    styleTextCss: 'status_success_text',
    text: 'status.order.completed',
    canCancel: true,
  },
  CANCELED: {
    styleBgCss: 'status_other',
    styleTextCss: 'status_other_text',

    text: 'status.order.canceled',
    canCancel: false,
  },
  REJECTED: {
    styleBgCss: 'status_fail',
    styleTextCss: 'status_fail_text',
    text: 'status.order.fail',
    canCancel: false,
  },
  NEW: {
    styleBgCss: 'status_fail',
    styleTextCss: 'status_fail_text',
    text: 'status.order.newOrder',
    canCancel: true,
  },
  PARTIALLY_FILLED: {
    styleBgCss: 'status_other',
    styleTextCss: 'status_other_text',
    text: 'status.order.partialTransactio',
    canCancel: true,
  },
  PARTIALLY_CANCELED: {
    styleBgCss: 'status_other',
    styleTextCss: 'status_other_text',
    text: 'status.order.partialRevocation',
    canCancel: false,
  },
  EXPIRED: {
    styleBgCss: 'status_other',
    styleTextCss: 'status_other_text',
    text: 'status.order.expired',
    canCancel: false,
  },
};
// 理财活期宝收益状态
export function getFinanceIncomeStatus(status: OrderStatusCode) {
  const zenLan: any = {
    1: 'finance.status.profit.01',
    2: 'finance.status.profit.02',
    3: 'finance.status.profit.03',
  };

  return zenLan[status];
}
// 理财活期宝订单状态
export function getFinanceOrderStatus(status: OrderStatusCode) {
  const zenLan: any = {
    1: 'finance.status.order.01',
    2: 'finance.status.order.02',
    3: 'finance.status.order.03',
  };

  return zenLan[status];
}
export enum ZnxAggType {
  SYSTEM = 'SYSTEM',
  DEPOSIT_WITHDRAW = 'DEPOSIT_WITHDRAW',
  SAFE = 'SAFE',
  AUTH = 'AUTH',
  COPY_ORDER = 'COPY_ORDER',
  CONTRACT = 'CONTRACT',
  ACTIVITY = 'ACTIVITY',
  VIP = 'VIP',
}

export enum ZnxDetailType {
  CONTRACT_TPSL_TRIGGER_SUCCESS = 'CONTRACT_TPSL_TRIGGER_SUCCESS',
  CONTRACT_TPSL_TRIGGER_FAIL = 'CONTRACT_TPSL_TRIGGER_FAIL',
}

/** 站内信可跳转页面（后端 jumpPage） */
export enum ZnxJumpPage {
  MY_COUPONS = 'MY_COUPONS',
}

export const ZNX_JUMP_PATH: Record<ZnxJumpPage, string> = {
  [ZnxJumpPage.MY_COUPONS]: '/welfare-center?tab=coupons',
};

export const AGGTYPE = [
  { value: 'SYSTEM', label: 'message.SYSTEM' },
  { value: 'DEPOSIT_WITHDRAW', label: 'message.DEPOSITWITHDRAW' },
  { value: 'SAFE', label: 'message.SAFE' },
  { value: 'AUTH', label: 'message.AUTH' },
  { value: 'COPY_ORDER', label: 'message.COPYORDER' },
  { value: 'CONTRACT', label: 'message.CONTRACT' },
  { value: 'ACTIVITY', label: 'message.ACTIVITY' },
  { value: 'VIP', label: 'message.VIP' },
];
